export enum PortalUsersErrors {
    PortalUserExist = 'already exists in the database',
    PasswordError = 'The password must contain'
}
